// extracted by mini-css-extract-plugin
export default {"google":"factor-icon_google__sFOX4","okta":"factor-icon_okta__FczkM","phone":"factor-icon_phone__a2ytd","passkey":"factor-icon_passkey__sfQru","mfaIcon":"factor-icon_mfaIcon__7irBs"};